import {loadLibrary} from "./Util";
import {LIB_URL} from '../App';

/* общие элементы интерфейса */

/* Переход по ссылке при выборе селекта */
$('.js-link-select').on('change', function () {
   window.location.href = $(this).val();
});

/* Если заход по прямой ссылке отмечаем это */
if (history.length == 1) {
    history.replaceState('entry', null);
}

/* Кнопка "назад", работает по принципу браузерной кнопки "назад" */
$('.js-back-link').on('click', function (e) {
    if (history.state != 'entry') {
        history.back();

        e.preventDefault();
    }
});

$('.js-pseudo-table').each(function (index, el) {
    generatePseudoTable($(el));
});

let isCalendarOnce = false;

//export function setDateCalendar(container) {
export function setDateCalendar() {
    if (!isCalendarOnce) {
        isCalendarOnce = true;

        App.D.one('calendar:defaults', () => {
            /* Календарь */
            $.datepicker.regional['ru'] = {
                closeText: 'Закрыть',
                prevText: 'Предыдущий',
                nextText: 'Следующий',
                currentText: 'Сегодня',
                monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
                monthNamesShort: ['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек'],
                dayNames: ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
                dayNamesShort: ['вск','пнд','втр','срд','чтв','птн','сбт'],
                dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
                weekHeader: 'Не',
                dateFormat: 'dd.mm.yy',
                firstDay: 1,
                isRTL: false,
                showMonthAfterYear: false,
                yearSuffix: ''
            };
            $.datepicker.setDefaults($.datepicker.regional['ru']);
        });

        App.H.on('click', '.date-calendar', function () {
            $(this).siblings('[data-date]').trigger('focus');
        });
    }
    /*let $dateWrap = container && container.length ? container : App.D;*/

    /*if (App.mobile) {
        $dateWrap.find('[data-date]').attr('type', 'date');
        $dateWrap.find('[data-date]').each(function (index, el) {
            if ($(el).data('min-date')) {
                let minusDate = $(el).data('min-date');
                let today = new Date();

                today.setDate(today.getDate() - minusDate);
                let correctDate = formatStrDate(today, '-');

                $(el).attr('min', correctDate);
            }
        });
    } else {*/
        if ($('input[data-date]').length) {
            loadLibrary(LIB_URL.JQ_UI, () => {
                App.D.trigger('calendar:defaults');
                App.D.on('focusin', '[data-date]', function() {
                    let $currField = $(this);
                    let minDate = $currField.data('min-date') ? parseInt($currField.data('min-date')) : '';
                    let yearFrom = $currField.data('year-from') ? $currField.data('year-from') : '-80';
                    let yearTo = $currField.data('year-to') ? $currField.data('year-to') : '+0';

                    $currField.datepicker({
                        minDate: minDate,
                        maxDate: $currField.is('[data-until-today]') ? '0d' : null,
                        yearRange: `${yearFrom}:${yearTo}`,
                        changeMonth: true,
                        changeYear: true,
                        onSelect: function () {
                            if ($(this).val().length > 0) {
                                $(this).removeClass('_error').closest('.js-input-wrap').addClass('_filled');
                            } else {
                                $(this).closest('.js-input-wrap').removeClass('_filled');
                            }

                            $currField.change();
                        }
                    });
                });
            });
        }
    /*}*/
}

// генерация мобилтной версии таблицы
function generatePseudoTable($table) {
    const $tableTr = $table.find('.pseudo-table__tr');
    const itemsCount = $tableTr.eq(0).find('.pseudo-table__td').length - 1;
    let itemsData = '';

    for (let i = 0; i < itemsCount; i++) {
        let currTrItems = '';

        for (let j = 1; j < $tableTr.length; j++) {
            const $currTr = $tableTr.eq(j);

            let currTr =
                `<div class="pseudo-mobile-table__tr">
                    <div class="pseudo-mobile-table__td">${$currTr.find('.pseudo-table__td').eq(0).find('div').html()}</div>
                    <div class="pseudo-mobile-table__td">${$currTr.find('.pseudo-table__td').eq(i+1).find('div').html()}</div>
                </div>`;

            currTrItems += currTr;
        }

        let currItem =
            `<div class="pseudo-table__item">
                    <div class="pseudo-table__item-title">${$tableTr.eq(0).find('.pseudo-table__td').eq(i+1).html()}</div>
                    ${currTrItems}
                </div>
            `;

        itemsData += currItem;
    }

    $table.find('.pseudo-table__mobile').html(itemsData);
}

export function setRangeSelect(selectFrom, selectTo) {
    let selectFromIndex;
    let selectToIndex;

    selectFrom.on('change', function () {
        selectFromIndex = selectFrom.find('option:selected').index();

        selectTo.find('option').prop('disabled', false);

        for (let i = 0; i < selectFromIndex; i++) {
            selectTo.find('option').eq(i).prop('disabled', true);
        }
    });

    selectTo.on('change', function () {
        selectToIndex = selectTo.find('option:selected').index();

        selectFrom.find('option').prop('disabled', true);

        for (let i = 0; i < selectToIndex; i++) {
            selectFrom.find('option').eq(i).prop('disabled', false);
        }
    });
}

export function formatStrDate(date, delimiter) {
    let dd = date.getDate();
    let mm = date.getMonth() + 1;
    let yy = date.getFullYear();

    if (dd < 10) {
        dd = '0' + dd;
    }

    if (mm < 10) {
        mm = '0' + mm;
    }

    return `${yy}${delimiter}${mm}${delimiter}${dd}`;
}

export function getDateStr(_str) {

    let d_arr = _str.split('.').reverse();

    return d_arr.join('/'); // дата в формате 2014/12/31
}


export function setTime() {
    App.D.one('focusin', '[data-time]', function(e) {
        $(e.target).trigger('blur');

        loadLibrary(LIB_URL.JQ_TIMEPICKER, () => {
            let $currField = $(this);
            let minTime = $currField.data('min-time') ? $currField.data('min-time') : '';
            let maxTime = $currField.data('max-time') ? $currField.data('max-time') : '';

            $currField.timepicker({
                timeFormat: 'HH:mm',
                interval: 30,
                minTime: '"' + minTime + '"',
                maxTime: '"' + maxTime + '"',
                defaultTime: '"' + minTime + '"',
                startTime: '"' + minTime + '"',
                dynamic: false,
                dropdown: true,
                scrollbar: true,
                change: function () {
                    if ($(this).val().length > 0) {
                        $(this).removeClass('_error').closest('.js-input-wrap').addClass('_filled');
                    } else {
                        $(this).closest('.js-input-wrap').removeClass('_filled');
                    }
                }
            });

            $(e.target).trigger('click');
            $(e.target).trigger('focus');
        });
    });
}
